module.exports = __webpack_public_path__ + "img/icon-tool-search.50cd9e91.svg";